/**
 *
 * CourseListItem
 *
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// antd component
import { List, Tooltip } from "antd";

// icons
import { WarningOutlined } from "@ant-design/icons";

// utils
import { convertTimeToString } from 'utils/moment/moment.utils';
import { getDayOfWeekObj } from "utils/helpers/helper.generateData";

function CourseListItem({
  element,
  searchString,
  activeEl,
  active,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("course-list-meta", className);
  const { t, i18n } = useTranslation();

  let responsible = element?.responsible?.description
    ? `${element?.responsible?.description?.lastname} ${
        element?.responsible?.description?.firstname
      }`
    : "";

  const courseTime = `${convertTimeToString(element?.course_time_start, "H:mm")} - ${convertTimeToString(element?.course_time_end, "H:mm")}`;
  const courseWeek = getDayOfWeekObj(element?.course_week) + `${courseTime ? ", " : ""}`;

  const courseClasses =
    element?.classes?.length > 0 &&
    element?.classes?.map(classInfo => classInfo?.title)?.join(", ");
  
  const studentAmountInfo = useMemo(
    () => {
      const length = `${element?.students?.length} ${i18n?.language == "de" ? t("labels.students") : t("labels.students")?.toLocaleLowerCase()}`;

      return (
        <span className="students-amount">
          {customHighlighter(length, searchString)}
        </span>
      );
    },
    [element?.students, i18n?.language, searchString],
  );

  return (
    element && (
      <List.Item.Meta
        className={childClassNames}
        style={{ borderLeft: `6px solid ${element?.subject?.color}` }}
        title={
          <>
            <span className="title">
              {customHighlighter(element?.course_code, searchString)}
            </span>
            <span className="class-title">
              {!!courseClasses ? (
                courseClasses
              ) : (
                <Tooltip
                  title={t("classes.fillClassInfo")}
                  className="tooltip-std"
                  key={"info-" + element?._id}
                >
                  <WarningOutlined />
                </Tooltip>
              )}
            </span>
          </>
        }
        description={
          <>
            <span className="course-time">
              {customHighlighter(courseWeek, searchString)}
              {customHighlighter(courseTime, searchString)}
            </span>
            {studentAmountInfo}
            {customHighlighter(responsible, searchString)}
            <span className="course-name">
              {customHighlighter(element?.subject?.name, searchString)}
            </span>
          </>
        }
      />
    )
  );
}

CourseListItem.defaultProps = {
  dateFormat: "DD.MM.YYYY",
  timeFormat: "HH:mm",
};
CourseListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func,
};

export default memo(CourseListItem);
